
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 49"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","d":"M26.624 39.35v1.5c-.1 2.2-1.5 3.9-3.1 3.9h-2.9c-1.7 0-3-1.8-3-3.9v-1.5"}}),_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#234652","d":"M22.4 43.95v1.5h3.2v-1.5m3.4-5.7v1.5c-.1 2.2-1.6 3.9-3.4 3.9h-3.1c-1.9 0-3.3-1.8-3.3-3.9v-1.5m3.9 2.8 5.8-.4M17 19.45l1.9 5.9 2-7.3 1.9 6.5m1.3 13.8v-4.3m-12.5-23.3-2-1.9m-1.3 13.6H5.5m18.6-17.4v-2.8m12.2 8.6 2.1-2.1m1.4 13.7h2.7M24 31.55v-5.3l3.1-8.3 1.9 7.3 2-5.9m-1.9 18.9c.4 0 .8-.2.9-.6 1.1-2.6 5.2-13 5.2-17.4 0-6.4-4.2-8.6-6.6-9.3-1.7-.5-2.6-.7-3.1-.8-.3-.1-.5-.3-.7-.6l-.8-1.8-.8 1.9c-.1.3-.4.5-.7.6-.5.1-1.5.4-3.4.8-2.5.6-6.3 2.9-6.3 9.3 0 4.4 4.1 14.8 5.2 17.4q.3.6.9.6z"}})])
          )
        }
      }
    